import { useState } from "react";
import { Apple } from "lucide-react";

/**
 * Robust meal image with a graceful fallback chain:
 * 1) Pollinations.ai with the full image_query (best — specific to dish)
 * 2) Pollinations.ai with just the dish name (simpler prompt, often faster)
 * 3) Soft beige placeholder with the dish name
 *
 * The placeholder is always rendered behind the <img>, so the user never sees a blank box.
 */
export default function MealImage({ name, query, eager = false, className = "" }) {
  const primary = `https://image.pollinations.ai/prompt/${encodeURIComponent(query || `${name} food photography natural light overhead`)}?width=720&height=480&nologo=true&model=flux`;
  const fallback = `https://image.pollinations.ai/prompt/${encodeURIComponent(`${name} plated dish food photography`)}?width=720&height=480&nologo=true`;
  const [stage, setStage] = useState(0); // 0 primary, 1 fallback, 2 placeholder

  return (
    <div className={`relative w-full h-full bg-[var(--bg-2)] overflow-hidden ${className}`}>
      {/* placeholder is always behind */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-[color:var(--ink-3)] gap-2 px-4 text-center">
        <Apple size={20} strokeWidth={1.3} className="text-[color:var(--accent)]" />
        <p className="font-serif text-sm leading-snug">{name}</p>
      </div>

      {stage < 2 && (
        <img
          key={stage}
          src={stage === 0 ? primary : fallback}
          alt={name}
          loading={eager ? "eager" : "lazy"}
          className="absolute inset-0 w-full h-full object-cover transition-opacity duration-500"
          onLoad={(e) => { e.currentTarget.style.opacity = "1"; }}
          onError={() => setStage((s) => s + 1)}
          style={{ opacity: 0 }}
        />
      )}
    </div>
  );
}
